import { createCRUDApi } from "@/lib/api-factory";
import type {
  ProductCategory,
  ProductCategoryCreate,
  ProductCategoryUpdate,
} from "@/types/products/api-types/product-category-types";

export const productCategoriesApi = createCRUDApi<ProductCategory, ProductCategoryCreate, ProductCategoryUpdate>(
  "/products/categories"
);
